import Apify from '@module/apify';

export default Apify({
  getGalleryItems: {
    path:
      'https://s3-eu-west-1.amazonaws.com/wetransfer-extra/advertgallery/tree.json',
    method: 'GET',
  },
});
